import { render, staticRenderFns } from "./ExcursionInner.vue?vue&type=template&id=05ff858b&"
import script from "./ExcursionInner.vue?vue&type=script&setup=true&lang=js&"
export * from "./ExcursionInner.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ExcursionInner.vue?vue&type=style&index=0&id=05ff858b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports